import { gql } from '@apollo/client';

export const CREATE_TOOL = gql`
  mutation MyMutation(
    $name: String!
    $department: String!
    $image: String
    $createdById: ID!
  ) {
    createSkill(
      input: {
        name: $name
        department: $department
        image: $image
        createdById: $createdById
      }
    )
  }
`;

export const GET_SKILLS = gql`
  query MyQuery {
    getSkills {
      id
      name
      department
      image
      createdById
    }
  }
`;

export const EDIT_TOOL = gql`
  mutation MyMutation(
    $id: ID!
    $name: String
    $department: String
    $image: String
  ) {
    editSkill(
      input: {
        skillId: $id
        name: $name
        department: $department
        image: $image
      }
    )
  }
`;

export const DELETE_TOOL = gql`
  mutation MyMutation($id: ID!) {
    deleteSkill(id: $id)
  }
`;
